import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { ThemeProvider } from "styled-components";
import styles from "./index.module.css";
import FullPageLoading from "../../components/FullPageLoading/FullPageLoading";
import NavBar from "../../components/Navbar/Navbar";

const Layout = ({ children }) => {
  const { loading } = useSelector((state) => state.fullPageLoaderSlice);
  return (
    <>
      <ThemeProvider theme={{ fontFamily: "Poppins" }}>
        <div className="d-lg-flex d-sm-flex">
          <NavBar />
          <main className={styles.main}>
            {children}
            {loading ? <FullPageLoading /> : null}
          </main>
        </div>
      </ThemeProvider>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.object.isRequired,
};

export default Layout;
